import React, { useState } from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label } from "rbx";
import { BooleanInput, SystemCodeSelect } from "../../../components/inputs";
import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = { Active: true };

function BookingCodeFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({
      ...inputs,
      [e.target.name]: e.target.name.includes("RecIdRef")
        ? parseInt(value)
        : value
    });
  };
  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs.Active}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <SystemCodeSelect
                icon="book-open"
                label="BOOKCATG"
                lookup={{ Category: "BookingCodes", CodeName: "BookCatg" }}
                name="CodeCatgRecIdRef"
                value={inputs.CodeCatgRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
BookingCodeFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default BookingCodeFilters;
